import { processHtmlAttributes } from "../../common/html-attributes/index.js";
$ const {
  name,
  class: inputClass,
  disabled,
  option: options = [],
  tabindex = 0,
  typeaheadTimeoutLength,
  a11ySelectedText = "selected",
  ...htmlInput
} = input;
<div ...processHtmlAttributes(htmlInput) key="options" role="listbox" class=["listbox__options", inputClass] tabindex:no-update=tabindex on-activeDescendantChange(component.isAutoSelection ? "handleListboxChange" : undefined) onKeydown(!component.isAutoSelection && "handleKeyDown")>
  <for|option, index| of=(options || [])>
    $ const {
      value,
      class: optionClass,
      text,
      selected,
      disabled,
      tabindex,
      icon,
      description,
      ...htmlOption
    } = option;
    $ var isSelected = index === state.selectedIndex;
    <div ...processHtmlAttributes(htmlOption) key="option[]" class:no-update=["listbox__option", optionClass] role="option" tabindex=(disabled ? -1 : tabindex) aria-disabled=(disabled && "true") aria-selected=(isSelected && "true") onClick(!component.isAutoSelection && "handleClick", index) onMousedown(component.isAutoSelection && "handleMouseDown")>
      <if(icon)>
        <span class="listbox__value">
          <${icon}/>
          <if(text)>
            <span>
              ${text}
            </span>
            <if(isSelected)>
              <span class="clipped">
                ${a11ySelectedText}
              </span>
            </if>
          </if>
          <if(description)>
            <span>
              <${description}/>
            </span>
          </if>
        </span>
      </if>
      <else>
        <span class="listbox__value">
          ${text}
          <if(isSelected)>
            <span class="clipped">
              ${a11ySelectedText}
            </span>
          </if>
        </span>
        <if(description)>
          <span class="listbox__description">
            <${description}/>
          </span>
        </if>
      </else>
      <ebay-tick-16-icon/>
    </div>
  </for>
</div>
<select hidden class="listbox__native" name=name>
  <for|option, i| of=(options || [])>
    <option value=option.value selected=(i === state.selectedIndex) class=option.class/>
  </for>
</select>